import { memo } from 'react'

import InfoPopper from './InfoPopper'
import type { Props as InfoPopperProps } from './InfoPopper'

const InfoPopperComponent = memo(InfoPopper)

export { InfoPopperProps }

export default InfoPopperComponent
